import { useContext } from "react";
import { EstimateCommentsContext } from "./EstimateCommentsContext";

export const useEstimateComments = () => {
  const context = useContext(EstimateCommentsContext);
  if (context === null) {
    throw new Error("EstimateCommentsContext cannot be null, please add a context provider");
  }
  return context;
};